// jQueryプラグイン
import 'jquery.easing';
/* -----------------------------------------------------
ページ内リンクのアニメーション
------------------------------------------------------- */
export function pageLinkAnimationFunc() {
  var scrTop;
  scrTop = $('#scrPageTop');
  scrTop.on('click', function () {
    $('body,html').animate({
      scrollTop: 0
    }, 1500, 'easeInOutQuint');
    return false;
  });
}

export function pageMoveAnkerFunc() {
  var letThisMap,letAreaListPosition,letChangeJs;
	
	letThisMap = $('#globalMap').find('.global_map');
	letChangeJs = $('#changeJs li');
	
	$(letThisMap.add(letChangeJs)).on('click', function () {
		letAreaListPosition = $('#areaList').offset().top;
		$('body,html').animate({
			scrollTop: letAreaListPosition
		}, 1000, 'easeInOutQuart');
		return false;
	});
}